export function parseQueryObject(query: any): string {
  let queryString: string = "";
  if (query && Object.keys(query).length > 0) {
    queryString = "?";
    Object.keys(query).forEach(k => {
      const value = query[k];
      if (value !== null && value !== undefined) {
        queryString += k + "=" + value.toString() + "&";
      }
    });
  }
  return queryString;
}


